import { motion } from 'framer-motion';

function PageHero({ eyebrow, title, text }) {
  return (
    <section className="page-hero">
      <div className="orb orb-one" aria-hidden="true" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <span className="eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        {text && <p>{text}</p>}
      </motion.div>
    </section>
  );
}

export default PageHero;